import { useCallback } from 'react';
import _get from 'lodash/get';
import { bestOptionsKey } from '../common-section-ui/pick-up-time-section-ui';

const useChooseDefaultSlotInTab = (
  timeSlotsInTabs,
  onTimeSlotClick,
  defaultBestOptionTimeSlot,
) =>
  useCallback(
    tabKey => {
      if (tabKey === bestOptionsKey && defaultBestOptionTimeSlot) {
        onTimeSlotClick(defaultBestOptionTimeSlot)();
      } else {
        const firstTimeSlotInTheTab = _get(timeSlotsInTabs, [
          tabKey,
          'timeSlots',
          0,
        ]);
        if (firstTimeSlotInTheTab) {
          onTimeSlotClick(firstTimeSlotInTheTab)();
        }
      }
    },
    [timeSlotsInTabs, onTimeSlotClick, defaultBestOptionTimeSlot],
  );

export default useChooseDefaultSlotInTab;
